import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BlockIcon from '@mui/icons-material/Block';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { renderFilledColorBox } from '../../../../utils/cssStyles';
import { InvoiceParseQueueStatus } from '../../../../utils/globalEnums';

// --- Status checks ---
export const isActiveParsingStatus = (status, newInvoice) =>
  (status === InvoiceParseQueueStatus.Processing || status === InvoiceParseQueueStatus.Enqueued) && newInvoice;

export const isCompletedParsingStatus = (status) => status === InvoiceParseQueueStatus.Completed;

export const isCanceledParsingStatus = (status) => status === InvoiceParseQueueStatus.StoppedByUser;

export const isFailedParsingStatus = (status) => status === InvoiceParseQueueStatus.Failed;

// --- Label ---
export const getParsingStatusLabel = (processingStatus) => {
  switch (processingStatus) {
    case InvoiceParseQueueStatus.Enqueued:
      return 'Queued';
    case InvoiceParseQueueStatus.Processing:
      return 'Processing';
    case InvoiceParseQueueStatus.Completed:
      return 'Completed';
    case InvoiceParseQueueStatus.Failed:
      return 'Retry';
    case InvoiceParseQueueStatus.StoppedByUser:
      return 'Canceled';
    case InvoiceParseQueueStatus.Unprocessable:
      return 'Failed';
    case InvoiceParseQueueStatus.Pending:
      return 'Pending';
    default:
      return '';
  }
};

// --- Status render map ---
export const STATUS_LABEL_MAP = {
  [InvoiceParseQueueStatus.Pending]: () => renderFilledColorBox('Pending', '#919EAB', <PendingOutlinedIcon />),
  [InvoiceParseQueueStatus.Enqueued]: () => renderFilledColorBox('Queued', '#919EAB', <AccessTimeIcon />),
  [InvoiceParseQueueStatus.Processing]: () => renderFilledColorBox('Processing', '#919EAB', <AutorenewIcon />),
  [InvoiceParseQueueStatus.Completed]: () =>
    renderFilledColorBox('Completed', 'success', <CheckCircleOutlineOutlinedIcon />),
  [InvoiceParseQueueStatus.StoppedByUser]: () => renderFilledColorBox('Canceled', 'error', <BlockIcon />),
  [InvoiceParseQueueStatus.Unprocessable]: () => renderFilledColorBox('Failed', 'error', <CancelOutlinedIcon />),
  [InvoiceParseQueueStatus.Failed]: (onClick, disabled) =>
    renderFilledColorBox('Retry', disabled ? '#919EAB' : 'error', <ReplayOutlinedIcon />, disabled ? null : onClick),
};

// --- Error parsing ---
export const ERROR_TYPES = {
  FILE_CORRUPTED: { match: 'File is corrupted', display: 'File is corrupted' },
  PASSWORD_PROTECTED: { match: 'File is password protected', display: 'File is password protected' },
  UNSUPPORTED_FORMAT: { match: 'is not supported', display: null }, // null = use original message
  PDF_CONVERSION_ERROR: { match: 'Error converting PDF to bytes', display: 'Error converting PDF to bytes' },
};
export const getErrorType = (errorMessage) => {
  if (!errorMessage) return null;
  const match = Object.values(ERROR_TYPES).find((type) => errorMessage.includes(type.match));
  if (!match) return null;
  return match.display ?? errorMessage.substring(errorMessage.indexOf(']') + 2); // skip "] "
};
